import { Colors } from '../../../../../../utils/resources/colors';
import { Fonts } from '../../../../../../utils/resources/fonts';
import { RepeatCardCSSStyleImpl } from './repeatcardcss';


export class RepeatLabelCSSStyleImpl extends RepeatCardCSSStyleImpl 
{

    getWrapperCSSStyle():object
    {
        return{
            minWidth:'24px',
            height:'24px',
            display:'flex',
            textAlign:'center',
            marginRight:'8.5px'
            
        };
    }

    getLabelCSSStyle(selected:boolean):object
    {
        return{
            width:'100%',
            // borderRadius:'48%',
            // border:selected?"1px solid "+this.getContext().getResources().getColor(Colors.color_36):"1px solid grey",
            // marginTop:'5px',
            // marginLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?'5px':'0px',
            // marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?'0':'5px', 
            height:'100%',
            marginBottom:'5px', 
            borderBottom:selected?'2px solid'+this.getResources().getColor(Colors.color_36):'2px solid'+this.getResources().getColor(Colors.color_31), 
            color:selected?this.getResources().getColor(Colors.color_36):this.getResources().getColor(Colors.color_31),
            lineHeight:'20px',
            fontSize:this.getResources().getFont(Fonts.h6),
            fontWeight:'bold'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/repeatcard/repeatlabelcss.tsx